import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { Talent } from '@libs/graphql-types';
import Typography from '@libs/ui/components/typography';

import BreakdownCategory from './breakdown-category';
import ByCountry from './by-country';
import { useDashboardData } from './hooks';
import LatestAdditions from './latest-additions';
import MyWorkforce from './my-workforce';
import OpenJobs from './open-jobs';
import Sources from './sources';

interface DashboardProps {}

const DashboardV2 = (props: DashboardProps) => {
  const { t } = useTranslation('dashboard');
  const { data, loading } = useDashboardData();
  const categoryData = data?.categoryAnalytics || [];
  const jobs = data?.jobs?.data || [];

  return (
    <ConnectedPageLayout
      documentTitle="Dashboard"
      isLoading={loading}
      drawerProps={{}}
    >
      <Typography variant="h5" paragraph>
        {t('common.dashboard')}
      </Typography>
      <Grid spacing={4} container direction="column">
        <Grid item width="100%">
          <OpenJobs jobs={jobs} />
        </Grid>
        <Grid item container spacing={4}>
          <Grid item container direction="column" xs={12} md={6} spacing={4}>
            <Grid item>
              <Sources data={data?.marketingSourceAnalytics || []} />
            </Grid>

            <Grid item>
              <BreakdownCategory data={categoryData} />
            </Grid>

            <Grid item>
              <LatestAdditions
                lastTalents={(data?.lastTalents as Talent[]) || []}
              />
            </Grid>
          </Grid>
          <Grid item container direction="column" xs={12} md={6} spacing={4}>
            <Grid item>
              <MyWorkforce
                totalTalents={data?.totalTalents?.custom_paginator_info?.total}
                pendingTalents={
                  data?.pendingTalents?.custom_paginator_info?.total
                }
                staticTalents={
                  data?.staticTalents?.custom_paginator_info?.total || 0
                }
                generalAnalytics={data?.generalAnalytics}
              />
            </Grid>
            <Grid item>
              <ByCountry data={data?.countryAnalytics || []} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ConnectedPageLayout>
  );
};

export default DashboardV2;
